import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Components as TableComponents } from './table.style';
import Icon from '../Icon';
import { Checkbox, Tooltip } from '../../components';
const Table = _ref => {
  let {
    defaultColumns,
    disableUpdate,
    tableActionColumns = [],
    primaryKey,
    headerPositionTop = '0px',
    headerCellBackground = '#F7F7F7',
    rowData = [],
    noDataMessage = 'No Records Found',
    gridLine = 'horizontal',
    fit = 'medium',
    onSort,
    hasStickyHeader = true,
    className = 'table',
    selectedRows = [],
    selectChangeEvent,
    selectAllEvent,
    checkIsDisabled,
    editTableCallback,
    addRowFlag,
    doubleClickCallback,
    activeRow,
    fullWidthTable,
    addedRowPosition = 'top',
    customRender,
    isAllEditable,
    expandedComponent,
    onRowClickCallback,
    expandedRow
  } = _ref;
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (!disableUpdate) {
      const defaultColumnsCopy = _toConsumableArray(defaultColumns);
      const allColumns = [].concat(_toConsumableArray(tableActionColumns), _toConsumableArray(defaultColumnsCopy));
      let leftStickyColumns = [];
      let rightStickyColumns = [];
      let currentLeftIndex = 0;
      let currentRightIndex = 0;
      const nonStickyColumns = allColumns.filter(item => !getFormattedValue(item, 'isFrozen', false) && getFormattedValue(item, 'isVisible', true));
      leftStickyColumns = allColumns.filter(item => getFormattedValue(item, 'isFrozen', false) && getFormattedValue(item, 'isVisible', true) && getFormattedValue(item, 'frozenPosition', 'left') === 'left').map(item => {
        const stickyElem = _extends(_extends({}, item), {
          left: currentLeftIndex
        });
        currentLeftIndex += item.width;
        return stickyElem;
      });
      rightStickyColumns = allColumns.filter(item => getFormattedValue(item, 'isFrozen', false) && getFormattedValue(item, 'isVisible', true) && getFormattedValue(item, 'frozenPosition', 'left') === 'right').map(item => {
        const stickyElem = _extends(_extends({}, item), {
          right: currentRightIndex
        });
        currentRightIndex += item.width;
        return stickyElem;
      });
      rightStickyColumns.reverse();
      setColumns([].concat(_toConsumableArray(leftStickyColumns), _toConsumableArray(nonStickyColumns), _toConsumableArray(rightStickyColumns)));
    }
  }, [defaultColumns, disableUpdate]);
  useEffect(() => {
    setRows(rowData);
  }, [rowData]);
  const onSortClick = (order, col) => {
    if (typeof onSort === 'function') {
      onSort(order, col);
    } else {
      // Sort mutate - before sort clone actual rows
      const sortedRows = _toConsumableArray(rows);
      sortedRows.sort((a, b) => {
        try {
          let varA;
          let varB;
          if (col.type === 'number') {
            return order === 'desc' ? (a[col.slotKey] - b[col.slotKey]) * -1 : a[col.slotKey] - b[col.slotKey];
          } else if (col.type === 'date') {
            varA = new Date(a[col.slotKey]).valueOf();
            varB = new Date(b[col.slotKey]).valueOf();
            return order === 'desc' ? varA - varB : (varA - varB) * -1;
          } else {
            varA = typeof a[col.slotKey] === 'string' ? a[col.slotKey].toUpperCase() : a[col.slotKey];
            varB = typeof b[col.slotKey] === 'string' ? b[col.slotKey].toUpperCase() : b[col.slotKey];
            let comparison = 0;
            if (varA > varB) comparison = 1;else if (varA < varB) comparison = -1;
            return order === 'desc' ? comparison * -1 : comparison;
          }
        } catch (err) {
          console.error(err);
          return 0;
        }
      });
      setRows(sortedRows);
    }
  };
  const getFormattedValue = (col, attrName, fallbackVal) => {
    return Object.prototype.hasOwnProperty.call(col, attrName) ? col[attrName] : fallbackVal;
  };
  const getTableCellValue = (row, col) => {
    const value = row[col.slotKey];
    return !value && typeof value !== 'number' || typeof value === 'undefined' || value === 'null' ? '' : value;
  };
  const selectAll = e => {
    const checked = e.target.checked;
    let availableRows = [];
    if (checked) {
      availableRows = rowData.filter(item => !isCheckboxDisabled(item));
    }
    if (typeof selectAllEvent === 'function') {
      selectAllEvent(availableRows, e);
    }
  };
  const selectRow = (e, row) => {
    const checked = e.target.checked;
    const existingRow = selectedRows.indexOf(row[primaryKey]);
    if (checked) {
      if (existingRow > -1) {
        selectedRows[existingRow] = row[primaryKey];
      } else {
        selectedRows.push(row[primaryKey]);
      }
    } else if (existingRow > -1) {
      selectedRows.splice(existingRow, 1);
    }
    const selectedItems = rowData.filter(item => selectedRows.indexOf(item[primaryKey]) > -1);
    if (typeof selectChangeEvent === 'function') {
      selectChangeEvent(selectedItems, row, e);
    }
  };
  const isCheckboxDisabled = row => {
    return typeof checkIsDisabled === 'function' ? checkIsDisabled(row) : false;
  };
  const isAllCheckboxEnabled = selectedRows => {
    const availableRows = rowData.filter(item => !isCheckboxDisabled(item));
    return availableRows.length ? selectedRows.length >= availableRows.length : false;
  };
  const isAllCheckboxDisabled = () => {
    const availableRows = rowData.filter(item => !isCheckboxDisabled(item));
    return !availableRows.length;
  };
  const onCellEdit = row => {
    if (row && typeof doubleClickCallback === 'function') {
      if (activeRow && activeRow[primaryKey] !== row[primaryKey] || !activeRow) {
        doubleClickCallback(row);
      }
    }
  };
  const getEditableAddedRow = () => {
    if (typeof editTableCallback === 'function') {
      return _jsx(_Fragment, {
        children: columns.map(col => _jsx(React.Fragment, {
          children: getFormattedValue(col, 'isVisible', true) && _jsx(TableComponents.Cell, _extends({
            className: "".concat(className, "-cell ").concat(col.slotKey),
            width: col.width,
            left: col.left,
            right: col.right,
            alignData: col.alignData,
            gridLine: gridLine,
            isFrozen: getFormattedValue(col, 'isFrozen', false),
            fullWidthTable: fullWidthTable,
            isRowSelect: col.slotKey === 'rowSelectioncheckbox'
          }, {
            children: _jsx(TableComponents.CellData, {
              children: editTableCallback('NEW', col, '')
            })
          }), col.slotKey)
        }, col.slotKey))
      });
    }
  };
  return _jsx(_Fragment, {
    children: columns && _jsx(TableComponents.Wrapper, _extends({
      fullWidthTable: fullWidthTable,
      className: "".concat(className, "-wrapper"),
      "$fit": fit
    }, {
      children: _jsxs(TableComponents.Table, _extends({
        defaultColumns: columns,
        primaryKey: primaryKey,
        className: className
      }, {
        children: [_jsx(TableComponents.Header, _extends({
          headerPositionTop: headerPositionTop,
          hasStickyHeader: hasStickyHeader,
          className: "".concat(className, "-header")
        }, {
          children: columns.map(col => _jsx(React.Fragment, {
            children: getFormattedValue(col, 'isVisible', true) && _jsx(TableComponents.Cell, _extends({
              className: "".concat(className, "-header-cell ").concat(col.slotKey),
              isHeaderCell: true,
              width: col.width,
              left: col.left,
              right: col.right,
              alignData: col.alignData,
              gridLine: gridLine,
              isFrozen: getFormattedValue(col, 'isFrozen', false),
              headerCellBackground: headerCellBackground,
              fullWidthTable: fullWidthTable,
              isRowSelect: col.slotKey === 'rowSelectioncheckbox'
            }, {
              children: _jsx(TableComponents.CellData, {
                children: col.slotKey === 'rowSelectioncheckbox' && getFormattedValue(col, 'hasSelectAll', true) && rows.length ? _jsx(Checkbox, {
                  checked: isAllCheckboxEnabled(selectedRows),
                  disabled: isAllCheckboxDisabled(),
                  type: "standard",
                  id: "".concat(className, "-selectall-checkbox"),
                  name: "selectAll",
                  onChange: event => selectAll(event)
                }) : _jsxs(_Fragment, {
                  children: [_jsx(Tooltip, _extends({
                    content: col.title
                  }, {
                    children: _jsx("span", {
                      children: col.title
                    })
                  })), getFormattedValue(col, 'sortable', false) && _jsxs(TableComponents.SortIcon, {
                    children: [_jsx(Icon, {
                      name: "chevron-up",
                      onClick: () => {
                        onSortClick('asc', col);
                      }
                    }), _jsx(Icon, {
                      name: "chevron-down",
                      onClick: () => {
                        onSortClick('desc', col);
                      }
                    })]
                  })]
                })
              })
            }))
          }, col.slotKey))
        })), _jsxs(_Fragment, {
          children: [addRowFlag && addedRowPosition === 'top' && _jsx(TableComponents.Row, _extends({
            gridLine: gridLine
          }, {
            children: getEditableAddedRow()
          })), rows.length && columns ? _jsxs(_Fragment, {
            children: [rows.map(row => _jsxs(_Fragment, {
              children: [_jsx(TableComponents.Row, _extends({
                className: "".concat(className, "-row row-").concat(row[primaryKey]),
                backgroundColor: row.backgroundColor,
                gridLine: gridLine,
                onClick: () => onRowClickCallback && onRowClickCallback(row)
              }, {
                children: columns.map(col => _jsx(React.Fragment, {
                  children: getFormattedValue(col, 'isVisible', true) && _jsx(TableComponents.Cell, _extends({
                    className: "".concat(className, "-cell ").concat(col.slotKey),
                    width: col.width,
                    left: col.left,
                    right: col.right,
                    alignData: col.alignData,
                    gridLine: gridLine,
                    isFrozen: getFormattedValue(col, 'isFrozen', false),
                    onDoubleClick: () => onCellEdit(row),
                    fullWidthTable: fullWidthTable,
                    isRowSelect: col.slotKey === 'rowSelectioncheckbox'
                  }, {
                    children: col.slotKey === 'rowSelectioncheckbox' ? _jsx(TableComponents.CellData, {
                      children: _jsx(Checkbox, {
                        checked: selectedRows.indexOf(row[primaryKey]) > -1,
                        disabled: isCheckboxDisabled(row) || false,
                        type: "standard",
                        onChange: e => selectRow(e, row),
                        id: "".concat(className, "-row-checkbox"),
                        name: "".concat(className, "-row-checkbox")
                      })
                    }) : _jsx(TableComponents.CellData, {
                      children: (isAllEditable || activeRow && activeRow[primaryKey] === row[primaryKey]) && editTableCallback ? editTableCallback('EDIT', col, row[col.slotKey], row) : col.render ? col.render(row, col) : customRender ? customRender(row, col) : _jsx(Tooltip, _extends({
                        content: getTableCellValue(row, col)
                      }, {
                        children: _jsx("span", {
                          children: getTableCellValue(row, col)
                        })
                      }))
                    })
                  }))
                }, "".concat(col.slotKey, "-").concat(row[primaryKey])))
              }), row[primaryKey]), expandedRow && expandedRow[primaryKey] === row[primaryKey] && expandedComponent && _jsx("div", {
                children: expandedComponent
              })]
            })), addRowFlag && addedRowPosition === 'bottom' && _jsx(TableComponents.Row, _extends({
              gridLine: gridLine
            }, {
              children: getEditableAddedRow()
            }))]
          }) : _jsx(TableComponents.NoData, _extends({
            className: "".concat(className, "-no-data")
          }, {
            children: noDataMessage
          }))]
        })]
      }))
    }))
  });
};
export default Table;